import * as React from "react";

import { RouteComponentProps } from "react-router";
import { Alert, Card, CardBody, CardFooter, Col, Container, Row } from "reactstrap";
import ResetForm from "./ResetForm";

import * as QueryString from "query-string";
import { qvals } from "../store/Interfaces";

type OwnProps =
    RouteComponentProps<{

    }>


interface accountState {
    isLoading: boolean;
}
export class Reset extends React.Component<OwnProps> {


    constructor(props: Readonly<OwnProps>) {
        super(props);
    }
    // This method is called when the component is first added to the document
    public componentDidMount() {
        this.ensureDataFetched();
    }

    private ensureDataFetched() {

    }
    public render() {
        let querystring = QueryString.parse(this.props.location.search);
        let target: qvals = new qvals();
        let query = Object.assign(target, querystring);
        if (query.w) {
            return (
                <Container>
                    <Row>
                        <Col />
                        <Col lg="8">
                                <ResetForm token={query.w} />

                        </Col>
                        <Col />
                    </Row>
                </Container>
            );

        } else {
            <Alert color="danger">Unauthorized Request</Alert>
        }
    }
}
